import * as Yup from "yup";
import checkout from "./form9";

const {
  formField9: {
    endow,
    departmentLevel,
    subordinateToTheDepartment,
    city,
    district,
    commune,

    endowTNDN,
    endowKHCN,
    addressEndow,
    confirmEndow,
    dateConfirmEndow
  },
} = checkout;

const validation9 = Yup.object().shape({
  [endow.name]: Yup.string().required(endow.errorMsg),
  [departmentLevel.name]: Yup.string().required(departmentLevel.errorMsg),
  [subordinateToTheDepartment.name]: Yup.string().required(subordinateToTheDepartment.errorMsg),
  [city.name]: Yup.string().required(city.errorMsg),
  [district.name]: Yup.string().required(district.errorMsg),
  [commune.name]: Yup.string().required(commune.errorMsg),

  [endowTNDN.name]: Yup.string().required(endowTNDN.errorMsg),
  [endowKHCN.name]: Yup.string().required(endowKHCN.errorMsg),
  [addressEndow.name]: Yup.string().when([endowKHCN.name], (endowKHCNValue, schema) => {
    return endowKHCNValue === 'true' ? schema.required(addressEndow.errorMsg) : schema;
  }),
  [confirmEndow.name]: Yup.string().when([endowKHCN.name], (endowKHCNValue, schema) => {
    return endowKHCNValue === 'true' ? schema.required(confirmEndow.errorMsg) : schema;
  }),
  [dateConfirmEndow.name]: Yup.number().when([endowKHCN.name], (endowKHCNValue, schema) => {
    return endowKHCNValue === 'true' ? schema.required(dateConfirmEndow.errorMsg) : schema;
  }),
});

export default validation9;
